<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mt-5">
        <ul class="heading-ul mb-5">
          <li>
            <router-link :to="{ path: '/accounting_rules' }" class="vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              <h4>{{ $t("accounting.label.viewrule") }}</h4>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData()"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteRulePopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("accounting.label.entityname") }}</b>
                </td>
                <td>{{ accountRuleData.officeName }}</td>
              </tr>
              <!-- <tr>
                <td>
                  <b>{{ $t("accounting.label.description") }}</b>
                </td>
                <td>{{ accountRuleData.description }}</td>
              </tr> -->
              <tr>
                <td>
                  <b>{{ $t("accounting.label.allowmultipledebitentries") }}</b>
                </td>
                <td>{{ accountRuleData.allowMultipleDebitEntries }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.allowmultiplecreditentries") }}</b>
                </td>
                <td>{{ accountRuleData.allowMultipleCreditEntries }}</td>
              </tr>
            </table>
          </div>
          <vs-table
            v-if="accountRuleData.debitTags"
            :data="accountRuleData.debitTags"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("accounting.label.debittags") }}
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("accounting.label.debittagid") }}</vs-th>
              <vs-th>{{ $t("accounting.label.debittagname") }}</vs-th>
              <vs-th>{{ $t("accounting.label.transactiontype") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="data"
                v-for="(accounts, index) in data"
              >
                <vs-td>{{ accounts.tag.id }}</vs-td>
                <vs-td>{{ accounts.tag.name }}</vs-td>
                <vs-td>{{ accounts.transactionType.value }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-table
            class="mt-4"
            v-if="accountRuleData.creditTags"
            :data="accountRuleData.creditTags"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("accounting.label.credittags") }}
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("accounting.label.credittagid") }}</vs-th>
              <vs-th>{{ $t("accounting.label.credittagname") }}</vs-th>
              <vs-th>{{ $t("accounting.label.transactiontype") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="data"
                v-for="(accounts, index) in data"
              >
                <vs-td>{{ accounts.tag.id }}</vs-td>
                <vs-td>{{ accounts.tag.name }}</vs-td>
                <vs-td>{{ accounts.transactionType.value }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteRulePopup"
      title="Rule"
      @deletePressed="deleteGLAccount()"
      @cancelPressed="deleteRulePopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      deleteRulePopup: false,
    };
  },

  computed: {
    ...mapState({
      accountRuleData: (state) => state.accounting.accountingRulesById,
    }),
  },
  methods: {
    async getTemplateDataById() {
      try {
        await this.$store.dispatch(
          "accounting/getAccountingRulesByIdAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteGLAccount() {
      try {
        this.deleteRulePopup = false;
        await this.$store.dispatch("accounting/deleteRuleAction", this.id);
        this.$router.push({ path: `/accounting_rules` });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editData() {
      this.$router.push(`/accounting_rules/edit_rule/${this.id}`);
    },
  },
  filters: {},
  async created() {
    this.id = this.$route.params.id;
    await this.getTemplateDataById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
